<template>
  <v-app >
    <cabecera/>
    <v-main style="background-color:#6D9886;" >
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container    >
        <v-row class="text-center">
          <v-col cols="12">
            <section id="eventos">
              <v-row  class="text-center">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <h1 class="display-1 font-weight-bold">Carnet</h1>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-btn class="primary" @click="imprimir">
                    <v-icon left>
                      fas fa-print
                    </v-icon>Imprimir</v-btn>
                </v-col>
              </v-row>

              <v-row justify="center" >

                <v-col cols="12" lg="8" sm="3"  >
                  <v-card  id="laentrada" elevation="10">
                    <v-card-title style="text-align: center;"> <p style="text-align: center;">Carnet {{elnegocio}} {{latemporada}}</p></v-card-title>
                    <v-card-text >
                    <v-row>
                      <v-col cols="12" lg="3" md="3" sm="6">
                        <v-row>
                          <v-col cols="12" lg="12" md="12" sm="12">
                            <v-img :src="foto"></v-img>
                          </v-col>
                        </v-row>

                      </v-col>
                      <v-col cols="12" lg="5" md="5" sm="6">
                        <v-row>

                            <v-col cols="12" lg="12" md="12" sm="12">
                              <p style=" font-size: 25pt;text-align: center; overflow-wrap: normal; line-height: 2rem;">{{nombrecompleto}}</p>
                            </v-col>

                              <v-col cols="12" lg="12" md="12" sm="12">
                               <p style="font-size: 18pt;text-align: center;">Tipo de Carnet :  {{tipocarnet}}</p>
                              </v-col>
                            <v-col cols="12" lg="12" md="12" sm="12">
                              <p style="font-size: 18pt;">{{dni}}</p>
                            </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" lg="4" md="6" sm="6">
                        <v-row>
                          <v-col cols="12" lg="12" md="12" sm="12">
                            <vue-qr :text="codigoUnico" :size="200" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </section>


          </v-col>
        </v-row>
      </v-container></v-main>
    <piepagina/>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>
<script>
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import VueQr from 'vue-qr';
import Vue2Img from "vue-2-img";
import "vue-2-img/dist/vue-2-img.css";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'carnet',
  title: 'Carnet | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
    VueQr
  },
  data ()  {
    return {
      overlay:false,
      output: null,
      encodedPdf: "",
    token:'',
      elnegocio:'',
      latemporada:'',
      foto:'',
      tipocarnet:'',
      nombrecompleto:'',
      dni:'',
      codigoUnico:''
    }
  },
  mounted() {
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.elnegocio = this.ticket.tipoCarnet.tipoCarnetTemporada.temporadaNegocio.negocio
              this.latemporada = this.ticket.tipoCarnet.tipoCarnetTemporada.temporada
              this.nombrecompleto = this.ticket.socioPrincipal.personaNombre + " " + this.ticket.socioPrincipal.personaApellidoPaterno + " " + this.ticket.socioPrincipal.personaApellidoMaterno
              this.nombrecompleto = this.nombrecompleto.trim()
              this.convertImgUrlToBase64(this.ticket.socioPrincipal.personaFoto,"foto")
              this.tipocarnet = this.ticket.tipoCarnet.tipoCarnet
              this.dni = this.ticket.socioPrincipal.personaDni
              this.codigoUnico = this.ticket.codigoUnico
              this.$router.push({ path: '/suscripciones' });
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      console.log("conectado")
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.elnegocio = this.ticket.tipoCarnet.tipoCarnetTemporada.temporadaNegocio.negocio
      this.latemporada = this.ticket.tipoCarnet.tipoCarnetTemporada.temporada
      this.nombrecompleto = this.ticket.socioPrincipal.personaNombre + " " + this.ticket.socioPrincipal.personaApellidoPaterno + " " + this.ticket.socioPrincipal.personaApellidoMaterno
      this.nombrecompleto = this.nombrecompleto.trim()
      this.convertImgUrlToBase64(this.ticket.socioPrincipal.personaFoto,"foto")
      this.tipocarnet = this.ticket.tipoCarnet.tipoCarnet
      this.dni = this.ticket.socioPrincipal.personaDni
      this.codigoUnico = this.ticket.codigoUnico
    }
  },
  watch: {
    '$store.state.usuario': function (){
      this.$router.push({ path: '/suscripciones' });
    },
  },
  methods:{
    async  imprimir(){
      var vm = this;
      let config = {
        target: "body",
        pageTarget: "#laentrada",
        captureHiddenClass: "vti__hidden",
        captureShowClass: "vti__show",
        captureActiveClass: "vti__active",
        title: "Entrada",
        author: "html-image-capture-service",
        maxItems: 50,
        fileNameSuffix: "entrada",
        pageWrapper: ".row",
        padding: 4,
        devStyle: false,
        pageHeight: null, // 612 for letter
        pageWidth: null, // 792 for letter
        pageUnits: "pt",
        returnAction: "download",
      };
      vm.encodedPdf = await Vue2Img().pdf(config);
      vm.downloadPDf(vm.encodedPdf);
    },
    convertImgUrlToBase64(url,what) {
      let self = this;
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); // use it if you try in a different origin of your web

      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;

        canvas.getContext('2d').drawImage(this, 0, 0);

        canvas.toBlob(
            function(source) {
              var newImg = document.createElement("img"),
                  url = URL.createObjectURL(source);

              newImg.onload = function() {
                // no longer need to read the blob so it's revoked
                URL.revokeObjectURL(url);
              };

              newImg.src = url;
            },
            "image/jpeg",
            1
        );

        // If you ever stumble at 18 DOM Exception, just use this code to fix it
        // let dataUrl = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        let dataUrl = canvas.toDataURL("image/jpeg");
        console.log("cek inside url : ", url);

        if(what === "background"){
          self.styleCarnet.backgroundImage = "url('"+ dataUrl+"')"
        }
        if(what === "foto"){
          self.foto = dataUrl
        }

      };
      image.src = url;
    },
    convertImgUrlToBase64Png(url,what) {
      let self = this;

      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); // use it if you try in a different origin of your web

      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;

        canvas.getContext('2d').drawImage(this, 0, 0);

        canvas.toBlob(
            function(source) {
              var newImg = document.createElement("img"),
                  url = URL.createObjectURL(source);

              newImg.onload = function() {
                // no longer need to read the blob so it's revoked
                URL.revokeObjectURL(url);
              };

              newImg.src = url;
            },
            "image/png",
            1
        );

        // If you ever stumble at 18 DOM Exception, just use this code to fix it
        // let dataUrl = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        let dataUrl = canvas.toDataURL("image/png");
        console.log("cek inside url : ", url);
        if(what === "logo"){
          self.logo270 = dataUrl
        }

      };
      image.src = url;
    },
  },
  computed: {
  // map `this.user` to `this.$store.getters.user`
...mapGetters({
    usuario:"usuario",
    ticket: "ticket"
  }),
    downloadPDf() {
      return (source) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = source;
        downloadLink.download = "entrada.pdf";
        downloadLink.click();
      };
    },
}
}
</script>
